import type { ImgHTMLAttributes } from 'react'

import { cn } from 'lib/utils'

import { imageMap } from './imageMap'
import type { ImageName } from './imageMap'

import './index.scss'

const mainClass = 'image'

interface ImageProps extends Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'alt'
> {
  name: ImageName
  alt?: string
  loading?: 'lazy' | 'eager'
  fetchPriority?: 'high' | 'low' | 'auto'
  decoding?: 'async' | 'auto' | 'sync'
}

export const Image = ({
  name,
  className = '',
  width,
  height,
  alt = '',
  loading = 'lazy',
  fetchPriority,
  decoding = 'async',
  sizes,
  ...restProps
}: ImageProps) => {
  const src = imageMap[name]

  return (
    <img
      className={cn(mainClass, className)}
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={loading}
      decoding={decoding}
      fetchPriority={fetchPriority}
      sizes={sizes}
      {...restProps}
    />
  )
}
